// extracted by mini-css-extract-plugin
module.exports = {"snackbarItem":"__snackbarItem___39xkv"};